/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.navigation
 */
function dropdownLinksConfig() {
    return {
        restrict: 'E',
        controller: dropdownLinksController,
        controllerAs: 'vm',
        template: require('./dropdownLinksView.html')
    };
}

dropdownLinksController.$inject = ['AnalyticsService', 'NavLinksService', 'UtilService'];
function dropdownLinksController (AnalyticsService, NavLinksService, UtilService) {
    var vm = this;

    vm.currentPlatformInfo = UtilService.getSiteSetting('current_platform_info');

    /**
     * Collapse accordion every time dropdown is shown
     */
    vm.toggleDropdown = function () {
        vm.headerDropdownLinks.forEach(function (headerLink) {
            headerLink.is_open = false;
        });
    };

    NavLinksService.getShowDropdownLinks().then(function (links) {
        vm.platformLinks = links.platformLinks;
        vm.headerDropdownLinks = links.headerDropdownLinks;
    });

    vm.trackNavEngagement = function (display, url, nestedLinks) {
        AnalyticsService.reportEvent('Nav Engaged', {
            location: 'header',
            url: url || null,
            value: display,
            nested_value: nestedLinks || null
        });
    };
}

module.exports = dropdownLinksConfig;